export const isProd = import.meta.env.PROD
const ENV_BASE_URL = import.meta.env.VITE_BASE_URL
export const API_URL = isProd ? "https://api.sonaris.ai" : (ENV_BASE_URL || "http://localhost:8000");

// console.log(isProd, API_URL, ENV_BASE_URL);